import React, { useState, useEffect, useCallback } from 'react';
import './FacultyHistory.css';
import collegeConfig from '../../config/collegeConfig';
import { FaArrowLeft, FaUserMd, FaHistory, FaCheckCircle } from 'react-icons/fa';

const API = collegeConfig.api.baseURL;
const token = () => localStorage.getItem('token');

const fmt = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export default function FacultyHistory({ onNavigate }) {
  const [current, setCurrent] = useState([]);
  const [previous, setPrevious] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API}/teachers/faculty-history/my-teachers`, {
        headers: { Authorization: `Bearer ${token()}` }
      });
      const data = await res.json();
      if (data.success) {
        setCurrent(data.current || []);
        setPrevious(data.previous || []);
      } else {
        setError(data.message || 'Failed to load faculty history');
      }
    } catch (err) {
      setError('Failed to load faculty history');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  return (
    <div className="fh-container">
      <div className="fh-header">
        <button className="fh-back-btn" onClick={() => onNavigate('dashboard')}>
          <FaArrowLeft />
        </button>
        <h2 className="fh-page-title">Faculty Assignment History</h2>
      </div>

      {loading && <div className="fh-loading">Loading...</div>}
      {error && <div className="fh-error">{error}</div>}

      {!loading && !error && (
        <>
          <div className="fh-card">
            <h3 className="fh-card-title"><FaCheckCircle className="fh-icon-current" /> Current Faculty</h3>
            {current.length === 0 ? (
              <p className="fh-empty">No faculty currently assigned.</p>
            ) : (
              <div className="fh-list">
                {current.map((entry) => (
                  <div className="fh-item fh-item-current" key={entry._id}>
                    <div className="fh-item-icon"><FaUserMd /></div>
                    <div className="fh-item-body">
                      <div className="fh-item-name">{entry.teacherName || 'Faculty'}</div>
                      <div className="fh-item-meta">{entry.courseName || 'Department'}</div>
                      <div className="fh-item-date">Assigned since {fmt(entry.assignedAt)}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="fh-card">
            <h3 className="fh-card-title"><FaHistory className="fh-icon-previous" /> Previous Faculty</h3>
            {previous.length === 0 ? (
              <p className="fh-empty">No previous faculty assignments.</p>
            ) : (
              <div className="fh-list">
                {previous.map((entry) => (
                  <div className="fh-item" key={entry._id}>
                    <div className="fh-item-icon fh-item-icon-past"><FaUserMd /></div>
                    <div className="fh-item-body">
                      <div className="fh-item-name">{entry.teacherName || 'Faculty'}</div>
                      <div className="fh-item-meta">{entry.courseName || 'Department'}</div>
                      <div className="fh-item-date">{fmt(entry.assignedAt)} – {fmt(entry.endedAt)}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
